/* global axios */
import ApiClient from './ApiClient';

class ScheduledMessagesAPI extends ApiClient {
  constructor() {
    super('scheduled_messages', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  getForConversation(conversationId) {
    return axios.get(`${this.url}?conversation_id=${conversationId}`);
  }

  createForConversation(conversationId, data, files = []) {
    // If there are files, use FormData
    if (files.length > 0) {
      const formData = new FormData();
      formData.append('scheduled_message[content]', data.content);
      formData.append('scheduled_message[scheduled_at]', data.scheduled_at);
      if (data.recurrence_type) {
        formData.append(
          'scheduled_message[recurrence_type]',
          data.recurrence_type
        );
      }
      if (data.recurrence_end_at) {
        formData.append(
          'scheduled_message[recurrence_end_at]',
          data.recurrence_end_at
        );
      }
      files.forEach(file => {
        // file can be a blob signed_id string or a File object
        formData.append('files[]', file);
      });
      return axios.post(
        `${this.baseUrl()}/conversations/${conversationId}/scheduled_messages`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
    }
    // No files, use regular JSON
    return axios.post(
      `${this.baseUrl()}/conversations/${conversationId}/scheduled_messages`,
      { scheduled_message: data }
    );
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  reactivate(id) {
    return axios.post(`${this.url}/${id}/reactivate`);
  }

  sendNow(id) {
    return axios.post(`${this.url}/${id}/send_now`);
  }

  bulkCancel(ids) {
    return axios.post(`${this.url}/bulk_cancel`, { ids });
  }

  bulkDestroy(ids) {
    return axios.delete(`${this.url}/bulk_destroy`, { data: { ids } });
  }
}

export default new ScheduledMessagesAPI();
